import img from '../../../assets/images/svg/right-arrow.svg';
import './rightArrow.css';

function RightArrow() {
  return (
    <div>
      <img src={img} alt="rightArrowBorder" />
    </div>
  );
}

export default RightArrow;
